"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _BrokenImage = _interopRequireDefault(require("@material-ui/icons/BrokenImage"));
var View = function View() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center justify-center w-full h-full min-h-70vh max-h-70vh bg-divider opacity-50"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex text-gray-light text-5xl"
  }, /*#__PURE__*/_react["default"].createElement(_BrokenImage["default"], {
    fontSize: "inherit",
    color: "inherit"
  })));
};
View.displayName = 'MissingEmailBody';
var _default = exports["default"] = View;
//# sourceMappingURL=index.js.map